import Body from "../components/Body";
import MediaTracker from "../components/media/MediaTracker";

export default function MediaTrackerPage() {
  return (
    <Body sidebar>
      <MediaTracker />
    </Body>
  );
}
